<div class="modal-body">
  <p class="centermodal__title" *ngIf="!waitingBiometry && !!currentSigner?.action">
    {{ 'signature.signDone.' + (currentSigner.action.name | lowercase) | translate: { andFilled: filledFields ? translateService.instant('signature.signDone.andFilled') : '' } }}
  </p>
  <p class="centermodal__title" *ngIf="!waitingBiometry && !currentSigner?.action">{{ 'signature.signDone.filledFields' | translate }}</p>
  <p class="centermodal__title" *ngIf="waitingBiometry">{{ 'documents.waitVerification' | translate }}</p>
  <app-lottie name="document-success" height="200"></app-lottie>
  <div class="centermodal__message-body centermodal__message-body--margin-normal" *ngIf="!!currentSigner?.action">
    <p class="centermodal__message" *ngIf="!waitingBiometry">
      <span>{{ 'documents.successfulElectronicSignature' | translate }}</span
      ><br />
      <span [innerHTML]="'documents.downloadSignedDocument' | translate"></span>
    </p>
    <p class="centermodal__message" *ngIf="waitingBiometry">
      {{ 'documents.successfulSignatureNotification' | translate }}
    </p>
  </div>
  <div class="centermodal__message-body centermodal__message-body--margin-normal" *ngIf="!currentSigner?.action">
    <p class="centermodal__message">
      <span>{{ 'documents.successfulDocumentFilling' | translate }}</span
      ><br />
      <span [innerHTML]="'documents.downloadFilledDocument' | translate"></span>
    </p>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="button" class="btn-M btn-filled" (click)="openSignedDocument()" *ngIf="!waitingBiometry">
      {{ 'button.download' | translate }}
    </button>
  </div>
</div>
